export default function PasswordStrength({ password, rules }) {
  const visible = password.length > 0;
  const passed = rules.filter(({ test }) => test(password)).length;
  const pct = passed / rules.length;
  const strengthColor = pct <= 0.2 ? "#f87171" : pct <= 0.6 ? "#fbbf24" : pct < 1 ? "#60a5fa" : "#34d399";
  const strengthLabel = pct <= 0.2 ? "Weak" : pct <= 0.6 ? "Fair" : pct < 1 ? "Good" : "Strong";

  return (
    <div style={{
      overflow: "hidden",
      maxHeight: visible ? "200px" : "0px",
      opacity: visible ? 1 : 0,
      transform: visible ? "translateY(0)" : "translateY(-6px)",
      transition: "max-height .35s ease, opacity .3s ease, transform .3s ease",
      marginTop: visible ? 12 : 0,
    }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
        <span style={{ fontSize: 11, color: "var(--text-muted)", letterSpacing: ".04em", textTransform: "uppercase" }}>Strength</span>
        <span style={{ fontSize: 11, fontWeight: 600, color: strengthColor, transition: "color .3s" }}>{strengthLabel}</span>
      </div>
      <div style={{ display: "flex", gap: 4, marginBottom: 12 }}>
        {rules.map((_, i) => (
          <div key={i} style={{
            flex: 1, height: 3, borderRadius: 99,
            background: i < passed ? strengthColor : "var(--border-light)",
            transition: "background .3s",
          }} />
        ))}
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
        {rules.map(({ label, test }) => {
          const ok = test(password);
          return (
            <div key={label} style={{
              display: "inline-flex", alignItems: "center", gap: 5,
              padding: "4px 10px", borderRadius: 99,
              fontSize: 11, fontWeight: 500,
              background: ok ? "rgba(52,211,153,.1)" : "var(--bg-surface)",
              border: `1px solid ${ok ? "rgba(52,211,153,.25)" : "var(--border-subtle)"}`,
              color: ok ? "#34d399" : "var(--text-muted)",
              transition: "all .25s",
            }}>
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                {ok ? <polyline points="20 6 9 17 4 12" /> : <><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></>}
              </svg>
              {label}
            </div>
          );
        })}
      </div>
    </div>
  );
}
